import * as sapStorage from "../../../store/localStorage/sapReducer"

export const getLocalStorageValue = (state, key) => sapStorage.getLocalStorageValue(state.localStorage.sap, key)
